import { render, staticRenderFns } from "./practitioner.vue?vue&type=template&id=0a7058df&scoped=true&"
import script from "./practitioner.vue?vue&type=script&lang=ts&"
export * from "./practitioner.vue?vue&type=script&lang=ts&"
import style0 from "./practitioner.vue?vue&type=style&index=0&id=0a7058df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7058df",
  null
  
)

export default component.exports